import React from 'react'
import { BalanceCard, CreditCard } from './BalanceCard/BalanceCard'
import { TableDemo } from './InvoiceTable/InvoiceTable'
import { OrgUserInvoicesTable } from './InvoiceTable/UserInvoiceTable'
import { hasAdminPrivileges } from '@/services/utils'
import { useGetOrgUserProfile } from '@/services/auth'
import { useActiveOrgId } from '@/hooks/useActiveOrgId'
import { User } from 'lucide-react'
import { useState } from 'react'

export const DashboardBilling = () => {
  const { orgId } = useActiveOrgId()
  const { data: orgProfile } = useGetOrgUserProfile(orgId)
  const [activeCreditCardTopUp, setActiveCreditCardTopUp] = useState(false)
  const isBillingEnabled = orgProfile?.org?.billing_enabled ?? false

  const isAdminUser = hasAdminPrivileges(orgProfile?.user_role?.role_name)

  if (isAdminUser) {
    return (
      <div data-testid="billing-admin-view">
        <h1 className="text-3xl font-medium mb-4" data-testid="billing-title">
          Billing And Invoice
        </h1>
        <BalanceCard userId={orgProfile?.org_user?.user_id} />
        <div className="mt-6" data-testid="admin-invoices-section">
          <TableDemo />
        </div>
      </div>
    )
  }

  return (
    <div data-testid="billing-user-view">
      <h1 className="text-3xl font-medium mb-4" data-testid="billing-title">
        Billing And Invoice
      </h1>
      {orgProfile?.org_user?.user_id ? (
        <>
          <div className="max-w-[500px]" data-testid="personal-credits-section">
            <CreditCard
              type="personal"
              title="Personal Credits"
              icon={User}
              userId={Number(orgProfile.org_user.user_id)}
              isActive={activeCreditCardTopUp}
              onOpenChange={setActiveCreditCardTopUp}
              isBillingEnabled={isBillingEnabled}
            />
          </div>
          <div className="mt-6" data-testid="user-invoices-section">
            <OrgUserInvoicesTable userId={orgProfile.org_user.user_id} />
          </div>
        </>
      ) : (
        <p data-testid="loading-message">
          Loading user info or no valid user found.
        </p>
      )}
    </div>
  )
}
